"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.match.js");
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var isToday = function isToday(date) {
  return new Date().setHours(0, 0, 0, 0) === new Date(date).setHours(0, 0, 0, 0);
};
var isDateOnly = function isDateOnly(date) {
  return String(date).match(/^\d{4}-\d{2}-\d{2}$/);
};
var parseDateTime = function parseDateTime(date, format) {
  return isDateOnly(date) ? (0, _momentTimezone["default"])(date).format(chooseFormat()) : (0, _momentTimezone["default"])(date).tz("Europe/London").format(chooseFormat(format));
};
var chooseFormat = function chooseFormat() {
  var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  switch (format) {
    case "weekDayDate":
      return "ddd DD MMM";
    case "weekDayYearDate":
      return "ddd DD MMM YYYY";
    case "dateTimeTextual":
      return "DD MMM YYYY [at] HH:mm";
    case "dateTimeFullDigit":
      return "DD/MM/YYYY HH:mm:ss";
    case "dateTimeFullTextual":
      return "DD MMM YYYY [at] HH:mm:ss";
    case "dateTimeTextualAtOn":
      return "[at] HH:mm [on] DD/MM/YYYY";
    case "dateTimeNumerical":
      return "DD/MM/YYYY [at] HH:mm:ss";
    case "onlyTime":
      return "HH:mm";
    case "onlyTimeWithSeconds":
      return "HH:mm:ss";
    default:
      return "DD/MM/YYYY";
  }
};
var _default = exports["default"] = function _default(_ref) {
  var date = _ref.date,
    format = _ref.format,
    ifEmptyVal = _ref.ifEmptyVal,
    className = _ref.className,
    testData = _ref.testData,
    _ref$forceFormat = _ref.forceFormat,
    forceFormat = _ref$forceFormat === void 0 ? false : _ref$forceFormat;
  if (!forceFormat) {
    if (isToday(date) && format === "dateTimeFullTextual") {
      format = "onlyTimeWithSeconds";
    } else if (isToday(date)) {
      format = "onlyTime";
    }
    ;
  }
  date = date ? parseDateTime(date, format) : ifEmptyVal || "";
  if (testData) return /*#__PURE__*/_react["default"].createElement("span", {
    "test-data": testData,
    className: className
  }, date);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: className
  }, date);
};